import { useCallback, useEffect, useState } from "react";
import {
  getLocale,
  Locale,
  localeLabels,
  setLocale,
  subscribeLocale,
  supportedLocales,
  t as translate,
} from "./index";

export type TranslateFn = (
  key: string,
  vars?: Record<string, string | number>
) => string;

export const useTranslation = (): {
  t: TranslateFn;
  locale: Locale;
  setLocale: (locale: string) => Locale;
  supportedLocales: Locale[];
  localeLabels: Record<Locale, string>;
} => {
  const [locale, setLocaleState] = useState<Locale>(getLocale);

  useEffect(() => subscribeLocale(() => setLocaleState(getLocale())), []);

  const t = useCallback<TranslateFn>(
    (key, vars = {}) => translate(key, vars),
    [locale]
  );

  return {
    t,
    locale,
    setLocale,
    supportedLocales,
    localeLabels,
  };
};
